import React from "react";
import "./enquiry.css";
import Form from "./Form";

const EnquiryForm = () => {
  return (
    <>
      <div className="container-fluid mailus-bg">
        <div className="container">
          <div className="row mail-row">
            <div className="col-md-6">
              <div className="mail-content-first">
                <p className="mail-content-obtain">
                  To make requests for
                  <br /> further information,{" "}
                  <span style={{ color: "#00436b" }}>
                  contact us 
                  </span>{" "}by Filling Out the Enquiry Form 
                  <br />
                </p>
                <p className="mail-content-contact">
                  Contact to require a detailed analysis and
                  <br /> assessment of your plan.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div className="mail-content-second">
                <Form/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnquiryForm;
